/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GetExpertFeedbacksParams,
  GetExpertTagsParams,
  GetLoggedInExpertTagsParams,
  GetPsychologistConsultsParams,
  GetPsychologistsParams,
  ModelsTheme,
  RequestFilterPsychologistsRequest,
  ResponseConsultsConsultFeedbackResponsePaginated,
  ResponsePsychologistConsultResponse,
  ResponsePsychologistGetPsychologistConsultsResponsePaginated,
  ResponsePsychologistResponse,
  ResponsePsychologistResponsePaginated,
  ResponseTagsExpertTag,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Psychologists<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Psychologists
   * @name GetClientConsult
   * @summary Get a consult (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/psychologists/consults/{consultId}
   * @secure
   * @response `200` `ResponsePsychologistConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientConsult = (consultId: number, params: RequestParams = {}) =>
    this.http.request<ResponsePsychologistConsultResponse, void>({
      path: `/api/v1/psychologists/consults/${consultId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetExpertFeedbacks
   * @summary  (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/psychologists/my-feedbacks
   * @secure
   * @response `200` `ResponseConsultsConsultFeedbackResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getExpertFeedbacks = (
    query: GetExpertFeedbacksParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseConsultsConsultFeedbackResponsePaginated, void>({
      path: `/api/v1/psychologists/my-feedbacks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetExpertTags
   * @summary Get Tags associated with the specified expert that is available for the client (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/psychologists/tags/{expertId}
   * @secure
   * @response `200` `(ResponseTagsExpertTag)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getExpertTags = (
    { expertId, ...query }: GetExpertTagsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseTagsExpertTag[], void>({
      path: `/api/v1/psychologists/tags/${expertId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetLoggedInExpertTags
   * @summary Get Tags associated with the logged-in expert that is available for the client (Auth policies: HostOrExpertPolicy)
   * @request GET:/api/v1/psychologists/tags
   * @secure
   * @response `200` `(ResponseTagsExpertTag)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getLoggedInExpertTags = (
    query: GetLoggedInExpertTagsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseTagsExpertTag[], void>({
      path: `/api/v1/psychologists/tags`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetLoggedPsychologist
   * @summary Get the dashboard user that is currently logged in (Auth policies: HostOrSupportOrExpertPolicy)
   * @request GET:/api/v1/psychologists/profile
   * @secure
   * @response `200` `ResponsePsychologistResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getLoggedPsychologist = (params: RequestParams = {}) =>
    this.http.request<ResponsePsychologistResponse, void>({
      path: `/api/v1/psychologists/profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologistById
   * @summary Get a single user with the psychologist role by ID, a GUID (Auth policies: HostOrSupportOrExpertPolicy)
   * @request GET:/api/v1/psychologists/{userId}
   * @secure
   * @response `200` `ResponsePsychologistResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getPsychologistById = (userId: string, params: RequestParams = {}) =>
    this.http.request<ResponsePsychologistResponse, void>({
      path: `/api/v1/psychologists/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologistConsults
   * @summary Get all the consults for a given psychologist matching the search parameters (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/psychologists/consults
   * @secure
   * @response `200` `ResponsePsychologistGetPsychologistConsultsResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getPsychologistConsults = (
    query: GetPsychologistConsultsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ResponsePsychologistGetPsychologistConsultsResponsePaginated,
      void
    >({
      path: `/api/v1/psychologists/consults`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologists
   * @summary Allow psychologists to get a list of existing psychologists (Auth policies: HostOrSupportOrExpertPolicy)
   * @request POST:/api/v1/psychologists
   * @secure
   * @response `200` `ResponsePsychologistResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getPsychologists = (
    query: GetPsychologistsParams,
    data: RequestFilterPsychologistsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponsePsychologistResponsePaginated, void>({
      path: `/api/v1/psychologists`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Psychologists
   * @name GetPsychologistThemes
   * @summary Get a list of themes associated with a psychologist (Auth policies: HostOrSupportOrExpertPolicy)
   * @request GET:/api/v1/psychologists/themes/{userId}
   * @secure
   * @response `200` `(ModelsTheme)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getPsychologistThemes = (userId: string, params: RequestParams = {}) =>
    this.http.request<ModelsTheme[], void>({
      path: `/api/v1/psychologists/themes/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
